/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PageType {
	GridView = 'GridView',
	FormView = 'FormView',
	Build = 'Build',
	Publish = 'Publish',
	Home = 'Home',
}
